/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import 'react-accessible-accordion/dist/minimal-example.css';
import { bindActionCreators as bind } from 'redux';
import { connect } from 'react-redux';

import { Result, Diagnostic } from '../../data/ducks';
import PlanStep from './PlanStep';
import { mp, getCampaign } from '../../constants/utils';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
// eslint-disable-next-line no-unused-vars
import {
  FAKE_RESPONSE_RETIREMENT_CONTRIBUTES,
  FAKE_RESPONSE_RETIREMENT_NOT_CONTRIBUTES,
} from '../../constants/questionnaires';

import { FlowHeader } from '../GoalsFlow/styles';
import { WhiteLogo, StyledResults } from '../shared/resultsStyles';
import Title from '../shared/Title';
import Text from '../shared/Text';

import DiagnosticTable from './DiagnosticTable';
import StatusTable from './StatusTable';
import { palette, breakpoints, flexCenter, flexColumn } from '../../constants/styles';
import Icon from '../shared/Icon';
import Graphic from '../landing/Graphic';
import GetStarted from '../landing/GetStarted';
import Section from '../landing/Section';
import redYellowPills from '../../images/png/redYellowPills.png';
import gift from '../../images/png/gift.png';
import greenPills from '../../images/png/greenPills.png';
import GetPlan from './GetPlan';
import FollowingCTA from '../shared/FollowingCTA';

const FishingMobile = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishingMobile.png';
const FishingDesktop = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishing.png';

const MIN_LOADING_TIME = 3000;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 50px;
  min-height: 100vh;
`;

const FinancialStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${palette.sweetGray};
  border-radius: 15px;
  width: 95%;
  padding: 5px 15px;
  margin-top: 50px;
  z-index: 300;

  ${({ outlier }) =>
    outlier &&
    css`
      background-color: white;
      border: 2px dashed ${palette.secondaryColor};
    `}
`;

const StyledDashedLine = styled.div`
  border-left: 2px dashed ${palette.sublimeGray};
  height: 95%;
  position: absolute;
  width: 10px;
  margin-left: 12px;
  margin-top: -18px;
  z-index: 1;
`;

const StyledInBetweenSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 130px;
`;

const StyledTableSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
  margin: 5em 0px;
`;

const StyledCTA = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledBackButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-decoration: underline;
  align-items: center;
  position: absolute;
  left: 5px;
  top: 5px;
  color: ${palette.sweetGray};
  font-size: 1em;
`;

const StyledFishingGraphic = css`
  width: 300px;

  ${breakpoints.mobileLandscape} {
    width: 310px;
  }

  ${breakpoints.tablet} {
    margin-top: 100px;
    width: 350px;
  }

  ${breakpoints.tabletLandscape} {
    width: 320px;
    align-self: flex-end;
    margin-left: 20px;
    margin-top: 75px;
  }

  ${breakpoints.desktop} {
    width: 430px;
  }
`;

export const ResultSection = styled(Section)`
  height: fit-content;
  justify-content: center;
  background-color: white;

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

export const FinalSection = styled(Section)`
  height: fit-content;
  justify-content: center;
  background-color: rgb(2, 39, 89);
  color: white;

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

export const CheckPointSection = styled(Section)`
  display: flex;
  width: 100%;
  height: fit-content;
  justify-content: center;
  background-color: rgb(2, 39, 89);

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

const StyledManosALaObra = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
`;

const RedYellowPills = styled.img.attrs({
  src: redYellowPills,
})`
  // position: absolute;
  // top: 105px;
  // left: 30%;
  width: 75px;
  height: 30px;
  margin: 0px 10px;
`;

const Gift = styled.img.attrs({
  src: gift,
})`
  position: absolute;
  top: -4px;
  width: 47px;
  height: 47px;
`;

const GreenPills = styled.img.attrs({
  src: greenPills,
})`
  // position: absolute;
  // top: 105px;
  // left: 60%;
  width: 75px;
  height: 30px;
  margin: 0px 10px;
`;

const StyledTitleRedYellow = css`
  position: absolute;
  top: 100px;
  left: 20%;

  ${breakpoints.tablet} {
  }
`;

const StyledTitleGreen = css`
  position: absolute;
  top: 100px;
  left: 50%;

  ${breakpoints.tablet} {
  }
`;

const StyledGetStartedCTA = styled(Link)`
  border: none;
  background-color: ${palette.secondaryColor};
  position: fixed;
  bottom: 0pt;
  left: 0pt;
  width: 100%;
  height: 50px;
  z-index: 400;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  ${flexCenter}
`;

const StyledCTAButton = css`
  background-color: ${palette.secondaryColorShy};
  &:hover {
    background-color: ${palette.secondaryColor};
  }
`;

const StyledSavePlan = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${palette.sweetGray};
  border-radius: 15px;
  width: 95%;
  padding: 40px 15px;
  z-index: 300;
  margin-bottom: 30px;
`;

const StyledModifiedDataDisclaimer = styled.div`
  ${flexColumn}
  align-items: flex-end;
  border: 1px solid ${palette.finautaOrange};
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 20px;
`;

const StyledStartOver = styled.a`
  text-align: center;
  color: ${palette.terciaryColor};
`;

class CustomResult extends Component {
  state = {
    loading: true,
    contactEmail: '',
    invalidEmail: false,
  };

  componentDidMount() {
    const { uuid } = this.props.match.params;
    mp(`[${getCampaign(window.location.href)}] | Diagnostic | Resultado`);
    this.props.fetchPlan({ uuid });
  }

  componentDidUpdate = () => {
    window.onbeforeunload = () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Resultados | Se va`);
    };
  };

  validateEmailAndSend = (contactEmail) => {
    const { uuid } = this.props.match.params;
    this.props.sendDiagnostic({ contactEmail, uuid });
  };

  getCurrentEntries = (data) => {
    const {
      currentIncome,
      currentMandatoryExpenses,
      currentOptionalExpenses,
      currentFinancialHealth,
      currentExpenses,
    } = data;

    let entries = [];

    if (!currentExpenses || currentExpenses.length === 0) {
      const lujitos = currentIncome - (currentMandatoryExpenses + currentFinancialHealth);

      entries.push({
        label: 'Gastos obligatorios',
        number: currentMandatoryExpenses,
        color: '#022759',
      });

      entries.push({
        label: 'Lujitos',
        number: lujitos,
        color: 'gray',
        info: {
          description:
            'Dinero que tienes disponible cada mes para consumo, tus gastos no obligatorios y el dinero que no esté comprometido está aquí.',
          breakdown: [],
        },
      });

      entries.push({
        label: 'Salud financiera',
        number: currentFinancialHealth,
        color: '#3DBC94',
        info: {
          description:
            'Dinero que gastas cada mes para mejorar tu salud financiera, como por ejemplo: pagar créditos, ahorro y seguros.',
          breakdown: [],
        },
      });
    } else {
      entries = currentExpenses;
    }
    return entries;
  };

  getCurrentStatus = (data) => {
    const {
      currentRetirementColor,
      currentRetirementText,
      currentSafetyColor,
      currentSafetyText,
      currentSavingsColor,
      currentSavingsText,
      currentDebtColor,
      currentDebtText,
      currentGoalsColor,
      currentGoalsText,
    } = data;

    const entries = [];

    const colorCodes = {
      red: '#800000',
      yellow: '#daa520',
      green: '#2E8B57',
    };

    entries.push({
      color: colorCodes[currentDebtColor],
      label: 'Deuda',
      icon: 'deudaToolNoFill',
      text: currentDebtText,
    });

    entries.push({
      color: colorCodes[currentRetirementColor],
      label: 'Retiro',
      text: currentRetirementText,
      icon: 'retiroToolNoFill',
    });

    entries.push({
      color: colorCodes[currentGoalsColor],
      label: 'Metas',
      text: currentGoalsText,
      icon: 'metasToolNoFill',
    });

    entries.push({
      color: colorCodes[currentSavingsColor],
      label: 'Ahorro',
      text: currentSavingsText,
      icon: 'ahorroToolNoFill',
    });

    if (currentSavingsText) {
      entries.push({
        color: colorCodes[currentSafetyColor],
        label: 'Seguridad',
        text: currentSafetyText,
        icon: 'lifebuoyNoFill',
      });
    }

    return entries;
  };

  getFutureStatus = (data) => {
    const entries = [];
    const {
      futureDebtColor,
      futureDebtText,
      futureGoalsColor,
      futureGoalsText,
      futureRetirementColor,
      futureRetirementText,
      futureSafetyColor,
      futureSafetyText,
      futureSavingsColor,
      futureSavingsText,
    } = data;

    const colorCodes = {
      red: '#800000',
      yellow: '#daa520',
      green: '#2E8B57',
    };

    entries.push({
      color: colorCodes[futureDebtColor],
      label: 'Deuda',
      icon: 'deudaToolNoFill',
      text: futureDebtText,
    });

    entries.push({
      color: colorCodes[futureRetirementColor],
      label: 'Retiro',
      text: futureRetirementText,
      icon: 'retiroToolNoFill',
    });

    entries.push({
      color: colorCodes[futureGoalsColor],
      label: 'Metas',
      text: futureGoalsText,
      icon: 'metasToolNoFill',
    });

    entries.push({
      color: colorCodes[futureSavingsColor],
      label: 'Ahorro',
      text: futureSavingsText,
      icon: 'ahorroToolNoFill',
    });

    if (futureSavingsText) {
      entries.push({
        color: colorCodes[futureSafetyColor],
        label: 'Seguridad',
        text: futureSafetyText,
        icon: 'lifebuoyNoFill',
      });
    }

    return entries;
  };

  getStepThreeEntries = (data) => {
    const {
      stepThreeDurationText,
      stepThreeFinancialHealth,
      stepThreeGoals,
      stepThreeGoalsText,
      stepThreeLifeSafety,
      stepThreeMedicalSafety,
      stepThreeRetirement,
      stepThreeRetirementText,
      stepThreeSafetyText,
    } = data;

    let total = stepThreeGoals + stepThreeRetirement;
    const entries = [];

    if (stepThreeLifeSafety) total += stepThreeLifeSafety;
    if (stepThreeMedicalSafety) total += stepThreeMedicalSafety;

    entries.push({
      amount: stepThreeRetirement,
      percentage: (stepThreeRetirement / total) * 100.0,
      name: 'Retiro',
    });

    entries.push({
      amount: stepThreeGoals,
      percentage: (stepThreeGoals / total) * 100.0,
      name: 'Metas',
    });

    if (stepThreeLifeSafety) {
      entries.push({
        amount: stepThreeLifeSafety,
        percentage: (stepThreeLifeSafety / total) * 100.0,
        name: 'Seguridad  - vida',
      });
    }

    if (stepThreeMedicalSafety) {
      entries.push({
        amount: stepThreeMedicalSafety,
        percentage: (stepThreeMedicalSafety / total) * 100.0,
        name: 'Seguridad - Gastos médicos',
      });
    }

    return entries;
  };

  render() {
    let steps = [];
    const { result, emailSent, sendingEmail, emailError } = this.props;
    const { loading } = this.state;
    let resultData = {};
    if (result.data) {
      const { data } = result;
      resultData = data.data;
      steps = resultData.children;
    }

    const { contactEmail, invalidEmail } = this.state;

    const { currentIncome, changes, email } = resultData;

    // eslint-disable-next-line no-nested-ternary
    return (
      <Fragment>
        <FlowHeader>
          {this.props.match.params.mode === 'preview' && (
            <StyledBackButton
              onClick={() => {
                window.history.back();
              }}
            >
              <Icon
                icon="arrowBack"
                style={{ marginRight: '3px' }}
                color={palette.sweetGray}
                size={20}
              />
              Regresar
            </StyledBackButton>
          )}
          <Link to="/" onClick={this.forceUpdate}>
            <WhiteLogo src={FinautaWhiteLogo} id="logo" />
          </Link>
        </FlowHeader>
        <StyledResults>
          <Container>
            <ResultSection>
              {changes && (
                <StyledModifiedDataDisclaimer>
                  <Text type="body1">
                    Tus gastos reportados fueron mayores a tus ingresos, por lo que tuvimos que
                    ajustar algunos de tus gastos.
                  </Text>
                  <StyledStartOver href="https://app.finauta.com/plan">
                    Vuelve a comenzar tu plan
                  </StyledStartOver>
                </StyledModifiedDataDisclaimer>
              )}
              <Title level={3} style={{ marginBottom: '1em' }} align="center">
                Diagnóstico financiero
              </Title>
              <Title level={5}>
                Así gastas tus{' '}
                <Title style={{ display: 'inline' }} level={5} color="#2299ee" bold>
                  <NumberFormat
                    value={currentIncome}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                    decimalScale={0}
                  />
                </Title>{' '}
                mensuales
              </Title>
              <DiagnosticTable
                entries={this.getCurrentEntries(resultData)}
                section="spending"
                borderColor="#ddd"
                colorPalette={[
                  palette.primaryColor,
                  'gray',
                  palette.secondaryColor,
                  palette.finautaOrange,
                ]}
              />
            </ResultSection>
            <ResultSection>
              <StyledTableSection>
                <Title level={3} style={{ marginBottom: '1em' }} align="center">
                  Así se ven tus finanzas
                </Title>
                <StatusTable entries={this.getCurrentStatus(resultData)} section="today" />
              </StyledTableSection>
            </ResultSection>
            <CheckPointSection pills>
              <Title level={3} color="white" align="center">
                Manos a la obra, te llevaremos
              </Title>
              <StyledManosALaObra>
                <Title level={3} color="white">
                  de
                </Title>
                <RedYellowPills />
                <Title level={3} color="white">
                  a
                </Title>
                <GreenPills />
              </StyledManosALaObra>
            </CheckPointSection>
            <ResultSection>
              <StyledTableSection>
                <Title level={3} style={{ marginBottom: '1em' }} align="center">
                  Muy pronto, así se verán tus finanzas
                </Title>
                <StatusTable entries={this.getFutureStatus(resultData)} section="tomorrow" />
              </StyledTableSection>
            </ResultSection>
            <CheckPointSection>
              <StyledInBetweenSection>
                <Title level={2} color="white" style={{ marginTop: '0px' }} align="center">
                  ¿Cómo lo lograremos?
                </Title>

                <Text color="white">Sencillo, con un plan financiero</Text>
                <Text color="white">Nosotros te lo regalamos</Text>
              </StyledInBetweenSection>
            </CheckPointSection>
            <ResultSection>
              <Title level={5} align="center" medium>
                Empieza aquí
              </Title>

              <div>
                <Icon
                  icon="startingBall"
                  size={25}
                  styles={css`
                    position: relative;
                    z-index: 300;
                  `}
                />
                <StyledDashedLine />
              </div>

              {steps.map((step) => (
                <PlanStep
                  key={step.text}
                  step={step}
                  planLink={encodeURIComponent(
                    `app.finauta.com/plan/res/${this.props.match.params.uuid}`,
                  )}
                />
              ))}
            </ResultSection>
            <ResultSection>
              <StyledSavePlan>
                <Gift />
                <GetPlan
                  onClick={this.validateEmailAndSend}
                  error={emailError}
                  loading={sendingEmail}
                  success={emailSent}
                />
              </StyledSavePlan>
              <Graphic
                initialHeight={219}
                mP={FishingMobile}
                mL={FishingMobile}
                tP={FishingDesktop}
                tL={FishingDesktop}
                d={FishingDesktop}
                l={FishingDesktop}
                styles={StyledFishingGraphic}
              />
            </ResultSection>
            <FinalSection>
              <Title level={2} color="white" style={{ marginBottom: '0.5em' }} align="center">
                ¿Qué sigue?
              </Title>
              <Title level={4} color="white" style={{ marginBottom: '1em' }} align="center">
                Implementa tu plan con nosotros
              </Title>
              <Text color="white" style={{ marginBottom: '6em' }}>
                Te ayudaremos poner en acción tu plan gratis y de la manera más rápida posible
              </Text>
            </FinalSection>
          </Container>
        </StyledResults>
        <FollowingCTA
          CTALink={
            this.props.match.params.mode === 'preview'
              ? '/plan'
              : `/contacto/plan/MainCTA/${encodeURIComponent(
                  `app.finauta.com/plan/res/${this.props.match.params.uuid}`,
                )}`
          }
          CTAText="Iniciar plan"
          CTAPrice="Gratis"
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  result: state.result.result,
  loading: state.result.loading,
  success: state.result.success,
  error: state.result.error,
  sendingEmail: state.diagnostic.sendingEmail,
  emailSent: state.diagnostic.emailSent,
  emailError: state.diagnostic.emailError,
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      fetchPlan: Result.Creators.fetchPlanRequested,
      sendDiagnostic: Diagnostic.Creators.sendDiagnosticRequested,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CustomResult);
